import { styled } from "@vitality-ds/system";
import BaseBaseSortableIconContainerStyles from "./styles/BaseSortableIconContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseSortableIconContainer = styled("div", BaseBaseSortableIconContainerStyles);